/**
 * Handles concealing of honeypots ant decoying elements
 */

(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("Decoys");

  Components.create('Decoys', {

    // IMPORTANT: use keywords that are not supposed to be really used
    Selectors: {
      handler: $('.direct-contact-email'),
    },

    conceal: function() {
      Components.Decoys.Selectors.handler.css('display', 'none').find("input").removeAttr('required');
    },

    init: function() {
      this.conceal();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);